export default __webpack_public_path__ + "static/media/steinitz.d2ee92bc.txt";